import { computed } from 'vue'
// types
import type { ComputedRef } from 'vue'
import type { BlockSectionLayoutProps } from '@ts-blocks/block-section-layout/interfaces'
import type { SectionDisciplineNeedsProps } from '@ts-sections/section-discipline-needs/interfaces'

interface SectionDisciplineNeedsHookOptions {
  section: () => SectionDisciplineNeedsProps
}

interface SectionDisciplineNeedsHookReturn {
  refTitle: ComputedRef<string>
  refDescription: ComputedRef<string>
  refBackgroundColor: ComputedRef<NonNullable<BlockSectionLayoutProps['backgroundColor']>>
}

export const useSectionDisciplineNeeds = ({ section }: SectionDisciplineNeedsHookOptions): SectionDisciplineNeedsHookReturn => {
  const refLayout = computed<BlockSectionLayoutProps | null>(() => section().layout ?? null)

  const refTitle = computed<string>(() => refLayout.value?.title ?? '')
  const refDescription = computed<string>(() => refLayout.value?.description ?? '')

  const refBackgroundColor = computed<NonNullable<BlockSectionLayoutProps['backgroundColor']>>(() => (
    refLayout.value?.backgroundColor ?? 'tertiary'
  ))

  return {
    refTitle,
    refDescription,
    refBackgroundColor,
  }
}
